import script from "./MultiVideoArchive.vue?vue&type=script&lang=ts&setup=true"
export * from "./MultiVideoArchive.vue?vue&type=script&lang=ts&setup=true"

import "./MultiVideoArchive.vue?vue&type=style&index=0&id=514d0329&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-514d0329"]])

export default __exports__